
import routeVisibleForRole from "../util/routeVisibleForRole";
import Profile from "../views/pages/auth/Profile";
import SubscribedUserDashboard from "../views/pages/dashboards/SubscribedUserDashboard";
import ReviewCompanyDetails from "../views/pages/subscribedUser/reviewCompany/Details";
import ReviewCompanyEdit from "../views/pages/subscribedUser/reviewCompany/Edit";
import ReviewCompanyList from "../views/pages/subscribedUser/reviewCompany/List";
import ReviewCompanyCreate from "../views/pages/subscribedUser/reviewCompany/Create";
import ReviewContactDetails from "../views/pages/subscribedUser/reviewContact/Details";
import ReviewContactEdit from "../views/pages/subscribedUser/reviewContact/Edit";
import ReviewContactCreate from "../views/pages/subscribedUser/reviewContact/Create";
import ReviewContactList from "../views/pages/subscribedUser/reviewContact/List";
import UserSettings from "../views/pages/settings/UserSettings";
import Trends from "../views/pages/reviews/Trends";
import AudienceList from "../views/pages/subscribedUser/reviewContact/AudienceList";
import UnansweredContacts from "../views/pages/reviews/UnansweredContacts";
import MyDrive from "../views/pages/drive/MyDrive";
import SharedWithMe from "../views/pages/drive/SharedWithMe";
import AdminList from "../views/pages/admin/List";
import AdminDetails from "../views/pages/admin/Details";
import AdminCreate from "../views/pages/admin/Create";
import AdminEdit from "../views/pages/admin/Edit";
import CompanyDetails from "../views/pages/company/Details";
import CompanyEdit from "../views/pages/company/Edit";
import CompanyList from "../views/pages/company/List";
import CompanyCreate from "../views/pages/company/Create";
import ContactDetails from "../views/pages/contact/Details";
import ContactEdit from "../views/pages/contact/Edit";
import ContactCreate from "../views/pages/contact/Create";
import ContactList from "../views/pages/contact/List";
import ProjectList from "../views/pages/project/List";
import ProjectCreate from "../views/pages/project/Create";
import ProjectDetails from "../views/pages/project/Details";
import ProjectEdit from "../views/pages/project/Edit";
import MeetingCreate from "../views/pages/report/Create";
import MeetingList from "../views/pages/report/List";
import MeetingDetails from "../views/pages/report/Details";
import SummaryList from "../views/pages/summary/List";
import ReportListByCompany from "../views/pages/report/ReportListByCompany";
import MeetingEdit from "../views/pages/report/Edit";
import NextStepsComplete from "../views/pages/nextSteps/NextStepsComplete";
import ReportList from "../views/pages/meetingReport/ReportList";

const subscribedUserRoutes = [
    {
        collapse: false,
        path: "/dashboard",
        name: "Dashboard",
        icon: "fas fa-window-restore",
        component: SubscribedUserDashboard,
        layout: "/user",
        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
    },
    {
        collapse: true,
        state: 'crmCollapse',
        name: 'CRM',
        icon: 'fa fa-bar-chart',
        invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [
            {
                collapse: true, // Indicates that this is a collapsible group
                state: "companyCollapse", // State key for controlling collapse
                name: "Company Database", // Name of the collapsible group
                icon: "fa fa-solid fa-building ", // Icon for the collapsible group
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
                views: [ // Array of routes that are part of this collapsible group
                    {
                        collapse: false,
                        path: "/company/show/:uniqueId",
                        name: "Company Details",
                        icon: " ",
                        component: ReviewCompanyDetails,
                        layout: "/user",
                        invisible: true,
                    },
                    {
                        collapse: false,
                        path: "/company/edit/:uniqueId",
                        name: "Company Edit",
                        icon: " ",
                        component: ReviewCompanyEdit,
                        layout: "/user",
                        invisible: true,
                    },
                    {
                        collapse: false,
                        path: "/company/list",
                        name: "List All Companies",
                        icon: " ",
                        component: ReviewCompanyList,
                        layout: "/user",
                        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
                    },
                    {
                        collapse: false,
                        path: "/company/create",
                        name: "Create New Company",
                        icon: " ",
                        component: ReviewCompanyCreate,
                        layout: "/user",
                        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
                    },
                ],
            },
            {
                collapse: true, // Indicates that this is a collapsible group
                state: "contactCollapse", // State key for controlling collapse
                name: "Contact Database", // Name of the collapsible group
                icon: "fa fa-solid fa-address-book ", // Icon for the collapsible group
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
                views: [
                    {
                        collapse: false,
                        path: "/contact/show/:uniqueId",
                        name: "Contact Details",
                        icon: " ",
                        component: ReviewContactDetails,
                        layout: "/user",
                        invisible: true,
                    },
                    {
                        collapse: false,
                        path: "/contact/edit/:uniqueId",
                        name: "Contact Edit",
                        icon: " ",
                        component: ReviewContactEdit,
                        layout: "/user",
                        invisible: true,
                    },
                    {
                        collapse: false,
                        path: "/contact/create/:uniqueId",
                        name: "Contact Create",
                        icon: " ",
                        component: ReviewContactCreate,
                        layout: "/user",
                        invisible: true,
                    },
                    {
                        collapse: false,
                        path: "/contact/list",
                        name: "List All Contacts",
                        icon: " ",
                        component: ReviewContactList,
                        layout: "/user",
                    },
                    {
                        collapse: false,
                        path: "/contact/create/",
                        name: "Create New Contact",
                        icon: " ",
                        component: ReviewContactCreate,
                        layout: "/user",
                        invisible: false,
                    },
                ],
            },
            {
                collapse: true, // Indicates that this is a collapsible group
                state: "projectCollapse", // State key for controlling collapse
                name: "Project Database", // Name of the collapsible group
                icon: "fa fa-briefcase ", // Icon for the collapsible group
                invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
                views: [
                    {
                        path: "/project/list",
                        name: "List All Projects",
                        icon: " ",
                        component: ProjectList,
                        layout: "/crm",
                        invisible: false
                    },
                    {
                        path: "/project/create",
                        name: "Create New Project",
                        icon: " ",
                        component: ProjectCreate,
                        layout: "/crm",
                        invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
                    },
                    {
                        path: "/project/show/:uniqueId",
                        name: "Project Show",
                        icon: " ",
                        component: ProjectDetails,
                        layout: "/crm",
                        invisible: true
                    },
                    {
                        path: "/project/edit/:uniqueId",
                        name: "Project Edit",
                        icon: " ",
                        component: ProjectEdit,
                        layout: "/crm",
                        invisible: true
                    },
                ],
            },
            {
                collapse: true, // Indicates that this is a collapsible group
                state: "reportCollapse", // State key for controlling collapse
                name: "Reports", // Name of the collapsible group
                icon: "fa fa-print ", // Icon for the collapsible group
                invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
                views: [
                    {
                        path: "/meetingReport/create/:companyId",
                        name: "Meeting",
                        icon: " ",
                        component: MeetingCreate,
                        layout: "/crm",
                        invisible: true,
                    },
                    {
                        path: "/meetingReport/list",
                        name: "List All Meetings",
                        icon: " ",
                        component: MeetingList,
                        layout: "/crm",
                        invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
                    },
                    {
                        path: "/meetingReport/show/:uniqueId",
                        name: "Meeting",
                        icon: " ",
                        component: MeetingDetails,
                        layout: "/crm",
                        invisible: true,
                    },
                    {
                        path: "/summary/:companyUid",
                        name: "Summaries",
                        icon: " ",
                        component: SummaryList,
                        layout: "/crm",
                        invisible: true
                    },
                    {
                        path: "/projectSummaries/:projectUid",
                        name: "Summaries By Project",
                        icon: " ",
                        component: SummaryList,
                        layout: "/crm",
                        invisible: true
                    },
                    {
                        path: "/summary",
                        name: "List All Summaries",
                        icon: " ",
                        component: SummaryList,
                        layout: "/crm",
                        invisible: false
                    },
                    {
                        path: "/meetingReport/create",
                        name: "Create New Report",
                        icon: " ",
                        component: MeetingCreate,
                        layout: "/crm",
                        invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
                    },
                    {
                        path: "/meetingReport/company/:uniqueId",
                        name: "Meeting",
                        icon: " ",
                        component: ReportListByCompany,
                        layout: "/crm",
                        invisible: true,
                    },
                    {
                        path: "/meetingReport/edit/:uniqueId",
                        name: "Meeting",
                        icon: " ",
                        component: MeetingEdit,
                        layout: "/crm",
                        invisible: true,
                    },
                    {
                        path: "/nextSteps/list/",
                        name: "Tasks",
                        icon: " ",
                        component: NextStepsComplete,
                        layout: "/crm",
                        invisible: true
                    },
                    {
                        path: "/project/listOld/",
                        name: "Project Events",
                        icon: " ",
                        component: ReportList,
                        layout: "/crm",
                        invisible: true,
                    },


                ],
            },

        ]
    },

    {
        collapse: true, // Indicates that this is a collapsible group
        state: "reviewsCollapse", // State key for controlling collapse
        name: "Trust Score", // Name of the collapsible group
        icon: "fas fa-poll", // Icon for the collapsible group
        invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [ // Array of routes that are part of this collapsible group
            {
                collapse: false,
                path: "/trends",
                name: "Results",
                icon: " ",
                component: Trends,
                layout: "/user",
                invisible: false,
            },
            {
                collapse: false,
                path: "/audience/list",
                name: "Audience List",
                icon: " ",
                component: AudienceList,
                layout: "/user",
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
            },
            {
                collapse: false,
                path: "/unanswered",
                name: "UnAnswered",
                icon: " ",
                component: UnansweredContacts,
                layout: "/user",
                invisible: !routeVisibleForRole(["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])
            },
        ],
    },
    {
        collapse: false,
        path: "/profile",
        name: "Profile",
        icon: " ",
        component: Profile,
        layout: "/user",
        invisible: true
    },
    {
        collapse: false,
        path: "/settings",
        name: "Settings",
        icon: " ",
        component: UserSettings,
        layout: "/user",
        invisible: true
    },
    {
        collapse: true,
        state: 'driveCollapse',
        name: 'Documents',
        icon: 'fa fa-folder',
        invisible: !routeVisibleForRole(["ROLE_FREE","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [
            {
                path: '/drive/my-drive/:uniqueId',
                name: 'My Drive',
                icon: ' ',
                component: MyDrive,
                layout: '/user',
                invisible: true
            },
            {
                path: '/drive/my-drive',
                name: 'My Drive',
                icon: ' ',
                component: MyDrive,
                layout: '/user',
                invisible:  !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
            },
            {
                path: '/drive/shared/:uniqueId/folder/:folderId',
                name: 'Shared with me',
                icon: ' ',
                component: SharedWithMe,
                layout: '/user',
                invisible: true
            },
            {
                path: '/drive/shared/:uniqueId',
                name: 'Shared with me',
                icon: ' ',
                component: SharedWithMe,
                layout: '/user',
                invisible: true
            },
            {
                path: '/drive/shared',
                name: 'Shared with me',
                icon: ' ',
                component: SharedWithMe,
                layout: '/user',
                invisible: false
            },

        ]
    },
    {
        collapse: true, // Indicates that this is a collapsible group
        state: "userCollapse", // State key for controlling collapse
        name: "Users", // Name of the collapsible group
        icon: "fa fa-users", // Icon for the collapsible group
        invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
        views: [
            {
                collapse: false,
                path: "/list",
                name: "List All Users",
                icon: " ",
                component: AdminList,
                layout: "/crm",
                invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
            },
            {
                collapse: false,
                path: "/show/:uniqueId",
                name: "User Details",
                icon: " ",
                component: AdminDetails,
                layout: "/crm",
                invisible: true,
            },
            {
                collapse: false,
                path: "/create",
                name: "Create User",
                icon: " ",
                component: AdminCreate,
                layout: "/crm",
                invisible: !routeVisibleForRole(["ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]),
            },
            {
                collapse: false,
                path: "/edit/:uniqueId",
                name: "Edit User",
                icon: " ",
                component: AdminEdit,
                layout: "/crm",
                invisible: true,
            },
        ],
    }



];


export default subscribedUserRoutes;
